var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resolvedComponent)?_c(_vm.resolvedComponent,_vm._b({tag:"component",attrs:{"slug":_vm.slug}},'component',_vm.componentProps,false)):_c('div',{staticClass:"sub-page d-flex justify-center align-center",staticStyle:{"min-height":"40vh"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }